import MediaTextDisplay from "./media-text-display.js";
import { window } from "./utils/server-safe-globals.js";
import { formatTime } from "./utils/time.js";
import { MediaUIAttributes } from "./constants.js";
class MediaDurationDisplay extends MediaTextDisplay {
  static get observedAttributes() {
    return [...super.observedAttributes, MediaUIAttributes.MEDIA_DURATION];
  }
  constructor() {
    super();
    this.container.innerHTML = formatTime(0);
  }
  attributeChangedCallback(attrName, oldValue, newValue) {
    if (attrName === MediaUIAttributes.MEDIA_DURATION) {
      this.container.innerHTML = formatTime(newValue);
    }
    super.attributeChangedCallback(attrName, oldValue, newValue);
  }
}
if (!window.customElements.get("media-duration-display")) {
  window.customElements.define("media-duration-display", MediaDurationDisplay);
}
var media_duration_display_default = MediaDurationDisplay;
export {
  media_duration_display_default as default
};
